export default "__VITE_ASSET__ttkRo1oU__"